import { SearchQueryOrderDirection } from "types/generated";

export const MIGRATION_QUEUE_FILTERS_TYPE = "openTofuMigrationQueue";
export const MIGRATION_QUEUE_FILTERS_ORDER_SETTINGS_KEY = "openTofuMigrationQueueFiltersOrder";
export const MIGRATION_QUEUE_TABLE_STORAGE_KEY = "openTofuMigrationQueueTable";
export const MIGRATION_QUEUE_LIMIT_STORAGE_KEY = "openTofuMigrationQueueLimit";

export const MIGRATION_QUEUE_FILTER_VARIABLES = {
  filterType: MIGRATION_QUEUE_FILTERS_TYPE,
  initialSortOption: "updatedAt",
  initialSortDirection: SearchQueryOrderDirection.Desc,
};

// Time fields stay sortable but can't be filter sections: the backend never populates
// possibleValuesTime, so their sections would always render empty.
export const MIGRATION_QUEUE_EXCLUDED_FILTER_FIELDS = ["createdAt", "updatedAt"];

export const MIGRATION_QUEUE_SUGGESTIONS_DICTIONARY: Record<string, string> = {
  state: "migration state",
  stackName: "name",
  stackSlug: "ID",
  createdAt: "first queued at",
  updatedAt: "last update",
};

export const CLEAR_QUEUE_REFETCH_QUERIES = [
  "GetOpenTofuMigrationCounts",
  "SearchOpenTofuMigrationQueue",
  "SearchOpenTofuMigrationQueueSuggestions",
];
